module.exports = __webpack_public_path__ + "images/xyz-fa5e2a31de28e28621c264c40bab64cf.jpg";